/**
 * Emerging Payments API
 * The public API for Emerging Payments.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PlacementContentDef } from './PlacementContentDef';
import { PlacementMetadata } from './PlacementMetadata';
import { SSRTextPlacementContentAllOf } from './SSRTextPlacementContentAllOf';
import { SSRTextPlacementContentAllOfContentData } from './SSRTextPlacementContentAllOfContentData';
import { HttpFile } from '../http/http';

export class SSRTextPlacementContent extends PlacementContentDef {
    'contentType': SSRTextPlacementContentContentTypeEnum;
    'contentData': SSRTextPlacementContentAllOfContentData;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contentType",
            "baseName": "contentType",
            "type": "SSRTextPlacementContentContentTypeEnum",
            "format": ""
        },
        {
            "name": "contentData",
            "baseName": "contentData",
            "type": "SSRTextPlacementContentAllOfContentData",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return super.getAttributeTypeMap().concat(SSRTextPlacementContent.attributeTypeMap);
    }
    
    public constructor() {
        super();
        this.contentType = "SSRTextPlacementContent";
    }
}


export type SSRTextPlacementContentContentTypeEnum = "SSRTextPlacementContent" ;

